export enum NavigationMenuPermissions {
  ViewDashboard = 'view_dashboard',
  ViewCompanies = 'view_companies',

  ViewSelfOnboarding = 'view_self_onboarding',

  ProductsManagement = 'products_management',
  ViewProductGroups = 'view_product_groups',
  ViewProductStructures = 'view_product_structures',

  FxAndFloatingRates = 'fx_and_floating_rates',
  ViewFloatingRates = 'view_floating_rates',
  ViewFXRates = 'view_fx_rates',

  ViewProgrammesAndDeals = 'view_programmes_and_deals',
  ViewProgrammes = 'view_programmes',
  ViewDeals = 'view_deals',
  ViewBankHolidayRules = 'view_bank_holiday_rules',
  ViewCreditNoteRules = 'view_credit_note_rules',

  ViewUserManagement = 'view_user_management',
  ViewServiceAccountManagement = 'view_service_account_management',
  ViewAuditTrail = 'view_audit_trail',
  ViewCompanyNotifications = 'view_company_notifications',
  ViewCompanySsoSettings = 'view_company_sso_settings',
  ViewCompanySecuritySettings = 'view_company_security_settings',

  ViewInstrumentUpload = 'view_instrument_upload',
  ViewAllocatedCreditNotes = 'view_allocated_credit_notes',

  ViewDisbursementFilesAdmin = 'view_disbursement_files_admin',
  ViewDisbursementFilesFunder = 'view_disbursement_files_funder',

  InstrumentApproval = 'instrument_approval',
  ApproveRejectInstrumentsPayerApprovalMaker = 'approve_reject_instruments_payer_approval_maker',
  ApproveRejectInstrumentsPayerApprovalChecker = 'approve_reject_instruments_payer_approval_checker',
  ManageRejectedInstrumentsPayerApproval = 'manage_rejected_instruments_payer_approval',
  MarkAsPaidWithoutFinancing = 'mark_as_paid_without_financing',

  FinanceRequest = 'finance_request',
  ApproveRejectInstrumentsSellerFinanceRequestMaker = 'approve_reject_instruments_seller_finance_request_maker',
  ApproveRejectInstrumentsSellerFinanceRequestChecker = 'approve_reject_instruments_seller_finance_request_checker',
  ManageRejectedInstrumentsSellerFinanceRequest = 'manage_rejected_instruments_seller_finance_request',
  ApproveRejectInstrumentsPayerFinanceRequestMaker = 'approve_reject_instruments_payer_finance_request_maker',
  ApproveRejectInstrumentsPayerFinanceRequestChecker = 'approve_reject_instruments_payer_finance_request_checker',
  ManageRejectedInstrumentsPayerFinanceRequest = 'manage_rejected_instruments_payer_finance_request',

  ViewIncomingPayments = 'view_incoming_payments',

  ViewDisbursementsSectionAdmin = 'view_disbursements_section_admin',
  ViewDisbursementsSectionFunder = 'view_disbursements_section_funder',
  InstrumentDisbursementsAdmin = 'instrument_disbursements_admin',
  InstrumentDisbursementsFunder = 'instrument_disbursements_funder',
  ViewRepayments = 'view_repayments',

  FinanceApprovalFunder = 'finance_approval_funder',
  ApproveRejectInstrumentsFunderApprovalMaker = 'approve_reject_instruments_funder_approval_maker',
  ApproveRejectInstrumentsFunderApprovalChecker = 'approve_reject_instruments_funder_approval_checker',
  ManageRejectedInstrumentsFunderApproval = 'manage_rejected_instruments_funder_approval',
  ManageFunderRejectedInstrumentsCustomer = 'manage_funder_rejected_instruments_customer',

  // Portal Admin Funder Approval Permissions
  ViewFunderApprovalPagesAdmin = 'view_funder_approval_pages_admin',
  ApproveRejectInstrumentsFunderApprovalMakerAdmin = 'approve_reject_instruments_funder_approval_maker_admin',
  ApproveRejectInstrumentsFunderApprovalCheckerAdmin = 'approve_reject_instruments_funder_approval_checker_admin',
  ManageRejectedInstrumentsFunderApprovalAdmin = 'manage_rejected_instruments_funder_approval_admin',

  ViewOutstandingInstruments = 'view_outstanding_instruments',

  ViewNplStatusApprovals = 'view_npl_status_approvals',

  CustomerViewCompanyDetails = 'customer_view_company_details',
  ManageOnboardingFormAndRules = 'manage_onboarding_form_and_rules',

  ReadyForFunding = 'ready_for_funding',

  ViewWebhookManagement = 'view_webhook_management',
  ViewSystemHealthNotifications = 'view_system_health_notifications',

  ViewNotificationTemplates = 'view_notification_templates',

  ViewContractTemplates = 'view_contract_templates',

  ViewCustomFields = 'view_custom_fields',
}
